export const IMAGE_WIDTH = 80;
export const IMAGE_HEIGHT = 107;
export const IMAGE_OPTION = { width: IMAGE_WIDTH * 2 };
export const SLIDE_MARGIN = 16;
export const SLIDES_TO_SHOW = 3;
export const VIDEO_ASPECT_RATIO = 0.75;
export const CAROUSEL_TOP_MARGIN = 20;

export const NAV_STYLES = {
  backgroundColor: '#fff',
  width: '40px',
  opacity: 1,
  bottom: 0,
  top: 'initial',
  left: 'initial',
  pointerEvents: 'initial',
};
